import React from 'react';
import { Image, Label, Tag, Text } from 'react-konva';
import useImage from 'use-image';
import { coverCrop, proxiedImageUrl } from '../../../utils/imageMergeTags';

interface Props {
	imageObj: any;
	ind: number;
}

const ViewImage: React.FC<Props> = ({ imageObj, ind }) => {
	// Image merge tag: the recipient's image is loaded through the backend proxy; if it is missing or
	// fails to load, the placed image is shown instead.
	const [personalized, personalizedStatus] = useImage(
		imageObj.personalizedUrl ? proxiedImageUrl(imageObj.personalizedUrl) : '',
		'anonymous'
	);
	const [fallback] = useImage(imageObj.imageUrl || imageObj.downloadUrl);
	const usePersonalized = !!imageObj.personalizedUrl && personalizedStatus === 'loaded' && !!personalized;
	// the placed image shows until (and unless) the recipient's image has loaded
	const image = usePersonalized ? personalized : fallback;
	const crop =
		usePersonalized && personalized && imageObj.width && imageObj.height
			? coverCrop(
					personalized.width,
					personalized.height,
					imageObj.width * Math.abs(imageObj.scaleX ?? 1),
					imageObj.height * Math.abs(imageObj.scaleY ?? 1)
			  )
			: undefined;

	return (
		<>
		<Image
			key={ind}
			listening={false}
			perfectDrawEnabled={false}
			image={image}
			crop={crop}
			width={imageObj.width}
			height={imageObj.height}
			rotation={imageObj.rotation}
			scaleX={imageObj.scaleX}
			scaleY={imageObj.scaleY}
			skewX={imageObj.skewX}
			skewY={imageObj.skewY}
			x={imageObj.x}
			y={imageObj.y}
			ref={(ref) => ref?.listening(false)}
		/>
		{imageObj.showMergeTagBadge && (
			<Label x={(imageObj.x || 0) + 4} y={(imageObj.y || 0) + 4} listening={false}>
				<Tag fill="#6D28D9" cornerRadius={4} opacity={0.9} />
				<Text text={`{{${imageObj.mergeTag}}}`} fontSize={12} padding={4} fill="#ffffff" />
			</Label>
		)}
		</>
	);
};

export default React.memo(ViewImage);
